import axios from 'axios';
import { getToken } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getPosSyncToken = async (branchId, cashRegisterId) =>
  (await axios.post(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/pos-sync/token`,
    {},
    withAuth()
  )).data;

export const resolvePosSyncWebsocketUrl = (path, token) => {
  const url = new URL(path, API_URL);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  if (token) {
    url.searchParams.set('token', token);
  }
  return url.toString();
};
